import type { RpcMethodParameters, Product } from '@scayle/storefront-nuxt'
import type { AsyncRpcOptions } from '~/utils/types'

type Options<DataT> = Partial<{
  params: MaybeRefOrGetter<RpcMethodParameters<'getProductsByEan'>>
  options?: AsyncRpcOptions<'getProductsByEan', Product[] | undefined, DataT>
}>

export function useAsyncProductsByEan<
  DataT = AsyncRpcResult<'getProductsByEan'>, // Transform function response type
>({ params, options }: Options<DataT> = {}, key?: string) {
  return useAsyncRpc<'getProductsByEan', Product[], DataT>(
    'getProductsByEan',
    toValue(params),
    options,
    key,
  )
}
